; ( $ => {


    // Magnific popup defaults
    $.extend(true, $.magnificPopup.defaults, {
        closeMarkup: '<button title="%title%" type="button" class="mfp-close mfp-close-btn">&#215;</button>',
        tClose: 'Close (Esc)',
        gallery: {
            tPrev: 'Previous',
            tNext: 'Next',
            tCounter: '%curr% / %total%'
        }
    })


    // Lightbox gallery
    if ($('.js-lightbox').length > 1) {
        $('.js-lightbox').magnificPopup({
            mainClass: 'mfp-fade',
            removalDelay: 300,
            type: 'image',
            //disableOn: 500,
            image: {
                titleSrc: 'data-lightbox-title'
            },
            gallery: {
                enabled: true
            },
            callbacks: {
                buildControls: function () {
                    this.contentContainer.append(this.arrowLeft.add(this.arrowRight))
                }
            }
        })
    } else {
        $('.js-lightbox').magnificPopup({
            mainClass: 'mfp-fade',
            removalDelay: 300,
            type: 'image',
            //disableOn: 500,
            image: {
                titleSrc: 'data-lightbox-title'
            }
        })
    }


    // Lightbox gallery delegated
    /*
    $('.js-lightbox-gallery').each(function () {
        var links = $(this).find('a')

        if ($(links).length > 1) {
            $(links).magnificPopup({
                mainClass: 'mfp-fade',
                removalDelay: 300,
                type: 'image',
                //disableOn: 500,
                image: {
                    titleSrc: 'data-lightbox-title'
                },
                gallery: {
                    enabled: true
                },
                callbacks: {
                    buildControls: function () {
                        this.contentContainer.append(this.arrowLeft.add(this.arrowRight))
                    }
                }
            })
        } else {
            $(links).magnificPopup({
                mainClass: 'mfp-fade',
                removalDelay: 300,
                type: 'image',
                //disableOn: 500,
                image: {
                    titleSrc: 'data-lightbox-title'
                }
            })
        }
    })
    */


    // Dialog
    /*
    $('.js-open-dialog').magnificPopup({
        type: 'inline',
        midClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 300
    })
    */

    $('.ajax-dialog').magnificPopup({
        type: 'ajax',
        midClick: true,
        mainClass: 'mfp-fade',
        removalDelay: 300,
        callbacks: {
            ajaxContentAdded: function () {
                forms.loadAjaxForm($(this.content).find('.loadForm'))
            }
        }
    })


    /*
    // Iframe
    /*
    $('.js-iframe').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 300,
        preloader: true
    })
    */

    
    $('.js-modal').magnificPopup({
        type: 'inline',
        midClick: true
    })


})(jQuery);